import React from 'react';
import PropTypes from 'prop-types';
import { AppProvider } from '@toolpad/core/AppProvider';
import { DashboardLayout, ThemeSwitcher } from '@toolpad/core/DashboardLayout';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Stack, IconButton, Tooltip, TextField } from '@mui/material';


import SearchIcon from '@mui/icons-material/Search';
import DashboardIcon from '@mui/icons-material/Dashboard';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import ConstructionIcon from '@mui/icons-material/Construction';
import EngineeringIcon from '@mui/icons-material/Engineering';
import FactoryIcon from '@mui/icons-material/Factory';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { createTheme } from '@mui/material/styles';

// Your navigation array (sidebar links)
const NAVIGATION = [
  {
    kind: 'header',
    title: 'Main items',
  },
  {
    segment: 'Dashboard',
    title: 'Dashboard',
    icon: <DashboardIcon />,
  },
  {
    segment: 'RM',
    title: 'Repair Maintenance',
    icon: <ConstructionIcon />,
  },
  {
    segment: 'FM',
    title: 'Fabrication & Modification',
    icon: <EngineeringIcon />,
  },
  {
    segment: 'PR',
    title: 'Project',
    icon: <FactoryIcon />,
  },
  {
    kind: 'divider',
  },
  {
    segment: 'Profile',
    title: 'Profile',
    icon: <AccountCircleIcon />,
  },
  {
    segment: 'Logout',
    title: 'Logout',
    icon: <ExitToAppIcon />,
  },
];

// Create a custom theme
const demoTheme = createTheme({
  colorSchemes: { light: true, dark: true },
});

function DashboardLayoutSlots({ children }) {
  const navigate = useNavigate(); // Navigation hook to navigate between pages

  return (
    <AppProvider navigation={NAVIGATION} theme={demoTheme}>
      <DashboardLayout
        slots={{
          appTitle: () => (
            <Stack direction="row" alignItems="center" spacing={2}>
              <Typography variant="h6">CMMS</Typography>
            </Stack>
          ),
          toolbarActions: () => (
            <Stack direction="row">
              <Tooltip title="Search" enterDelay={1000}>
                <div>
                  <IconButton
                    type="button"
                    aria-label="search"
                    sx={{ display: { xs: 'inline', md: 'none' } }}
                  >
                    <SearchIcon />
                  </IconButton>
                </div>
              </Tooltip>
              <TextField
                label="Search"
                variant="outlined"
                size="small"
                sx={{ display: { xs: 'none', md: 'inline-block' }, mr: 1 }}
              />
              <ThemeSwitcher />
            </Stack>
          ),
        }}
      >
        {/* Render the page-specific content passed as children */}
        {children}
      </DashboardLayout>
    </AppProvider>
  );
}

DashboardLayoutSlots.propTypes = {
  children: PropTypes.node,
};

export default DashboardLayoutSlots;
